"use client"

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react"
import { CheckIcon, ChevronsUpDownIcon } from "lucide-react"
import { FormControl, FormItem } from "components/ui/form";
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import { Controller } from "react-hook-form";
import { useGetJustificationActiveForDivergenceQuery } from "@/services/justification";

export default function SelectCellJustificationWithSearch({
    justification,
    rowId,
    control,
}: {
    justification?: number;
    rowId: string;
    control: any;
}) {
    const { data } = useGetJustificationActiveForDivergenceQuery();

    return (
        <Controller
            control={control}
            name={`divergence.justification_${rowId}`}
            defaultValue={justification ? justification.toString() : ""}
            render={({ field }) => {
                const [open, setOpen] = React.useState(false)
                
                const selectedItem = data?.find((item: any) => item.id.toString() === field.value)

                return (
                    <FormItem>
                        <Popover open={open} onOpenChange={setOpen}>
                            <PopoverTrigger asChild>
                                <FormControl>
                                    <Button
                                        variant="outline"
                                        role="combobox"
                                        aria-expanded={open}
                                        className="w-full justify-between text-gray-400 !border !border-none text-[14px]"
                                    >
                                        {selectedItem
                                            ? selectedItem.name
                                            : "Selecione uma justificativa"}
                                        <ChevronsUpDownIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                                    </Button>
                                </FormControl>
                            </PopoverTrigger>
                            <PopoverContent className="w-full p-2 z-[90]">
                                <Command>
                                    <CommandInput placeholder="Buscar justificativa..." />
                                    <CommandList>
                                        <CommandEmpty>Nenhuma justificativa encontrada.</CommandEmpty>
                                        <CommandGroup>
                                            {data?.map((item: any) => (
                                                <CommandItem
                                                    key={item.id}
                                                    value={item.name}
                                                    onSelect={() => {
                                                        field.onChange(item.id.toString())
                                                        setOpen(false)
                                                    }}
                                                    className="cursor-pointer"
                                                >
                                                    <CheckIcon
                                                        className={cn(
                                                            "mr-2 h-4 w-4",
                                                            field.value === item.id.toString() ? "opacity-100" : "opacity-0"
                                                        )}
                                                    />
                                                    {item.name}
                                                </CommandItem>
                                            ))}
                                        </CommandGroup>
                                    </CommandList>
                                </Command>
                            </PopoverContent>
                        </Popover>
                        {/* <FormMessage>
            {errors.divergence?.[`justification_${rowId}`]?.message}
          </FormMessage> */}
                    </FormItem>
                )
            }}
        />
    );
}
